import { Copy, FileText, Image as ImageIcon, Loader2, Sparkles, Type, ExternalLink } from "lucide-react";
import { toast } from "sonner";

const ACTIONS = [
  ["image", "Imagen de marca", "Plantilla FiinBridge con tu nombre, WhatsApp y QR", ImageIcon],
  ["ai_image", "Imagen creativa IA", "Fotografía generada con IA + capa de marca", Sparkles],
  ["copy", "Textos IA", "Instagram, LinkedIn, WhatsApp y guion de reel", Type],
  ["flyer", "Flyer PDF", "Una hoja con modalidades, requisitos y tu QR", FileText],
];

export const MarketingActions = ({ owner, busy, onRun }) => (
  <div className="space-y-4">
    <div className="ink rounded-2xl p-5" data-testid="mkt-owner">
      <div className="text-[10px] uppercase tracking-[0.18em] text-[#FFC629] font-semibold">Tu marca en cada material</div>
      <div className="font-display font-bold text-white mt-1" data-testid="mkt-owner-name">{owner.name}</div>
      <div className="text-xs text-white/60">{owner.franchise}{owner.phone ? ` · WhatsApp ${owner.phone}` : " · sin WhatsApp (edítalo en Mi página)"}</div>
      <div className="mt-3 flex items-center gap-2">
        <code className="text-[11px] text-white/80 truncate flex-1" data-testid="mkt-owner-link">{owner.link}</code>
        <button type="button" data-testid="mkt-copy-link" onClick={() => { navigator.clipboard.writeText(owner.link); toast.success("Liga copiada"); }} className="text-white/70 hover:text-white"><Copy size={14} /></button>
        <a href={owner.link} target="_blank" rel="noreferrer" className="text-white/70 hover:text-white" data-testid="mkt-open-link"><ExternalLink size={14} /></a>
      </div>
      <p className="text-[11px] text-white/45 mt-2">Cada lead, simulación u onboarding que llegue por esta liga o su QR queda atribuido a ti{owner.site ? ` (micrositio /${owner.site})` : ` (ref ${owner.ref})`}.</p>
    </div>
    <div className="grid sm:grid-cols-2 gap-3" data-testid="mkt-actions">
      {ACTIONS.map(([k, t, d, Icon]) => (
        <button key={k} type="button" data-testid={`mkt-run-${k}`} disabled={!!busy} onClick={() => onRun(k)} className="text-left rounded-2xl border border-border bg-white p-4 hover:border-[#FF7A00] transition-colors disabled:opacity-60">
          <div className="flex items-center gap-2 font-display font-bold text-sm">{busy === k ? <Loader2 size={16} className="animate-spin text-[#FF7A00]" /> : <Icon size={16} className="text-[#FF7A00]" />}{t}</div>
          <p className="text-xs text-[#575757] mt-1">{busy === k ? "Generando… puede tardar unos segundos" : d}</p>
        </button>))}
    </div>
  </div>
);
